import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@mui/material';
import { Payment } from '../../../models/PaymentHistory';
import { formatNumber } from '../../../utils';

interface PaymentHistoryDetailsProps {
  element: Payment;
}

export const PaymentHistoryDetails: FC<PaymentHistoryDetailsProps> = ({ element }) => {
  const { t } = useTranslation();
  const isMobile = useMediaQuery('(max-width:767px)');
  const isDiscountBonusPayment = Math.abs(element.BonusAmount) > 0 || Math.abs(element.Discount) > 0;
  const priceBeforeDiscount = Math.abs(element?.Amount) + Math.abs(element.Discount) + Math.abs(element.BonusAmount);

  return (
    <div className="payment-details">
      {!isMobile ? (
        <p>
          {formatNumber(Math.abs(element?.Amount))} {t('common.uah')}
        </p>
      ) : null}
      {element.TypeID === 2 && isDiscountBonusPayment ? (
        <>
          <span>
            <span>{t('paymentHistory.beforeDiscount')}</span>{' '}
            <span>
              {formatNumber(priceBeforeDiscount)} {t('common.uah')}
            </span>
          </span>
          {element.Discount !== 0 && (
            <span>
              <span>{t('paymentHistory.usedDiscount')}</span>{' '}
              <span>
                -{formatNumber(Math.abs(element.Discount))} {t('common.uah')}
              </span>
            </span>
          )}
          {element.BonusAmount !== 0 && (
            <span>
              <span>{t('paymentHistory.usedBonuses')}</span> <span>{formatNumber(Math.abs(element.BonusAmount))}</span>
            </span>
          )}
        </>
      ) : null}
      {element.TypeID === 2 && element.BonusIncome !== 0 ? (
        <span>
          <span>{t('paymentHistory.accruedBonuses')}</span> <span>{formatNumber(Math.abs(element.BonusIncome))}</span>
        </span>
      ) : null}
      {element.TypeID === 4 && element.BonusAmount !== 0
        ? element.BonusAmount !== 0 && (
            <span>
              <span>{t('servicePayment.backBonus')}</span> <span>{formatNumber(Math.abs(element.BonusAmount))}</span>
            </span>
          )
        : null}
    </div>
  );
};
